module.exports = "https://static.wmbcdn.com/uniweb/images/10467244cc508633ef6da72e657487bb.webp";